import { firestoreService } from '../services/firestoreService';

export const fetchFunds = async () => {
  try {
    const filters = [{ field: 'active', operator: '==', value: true }];
    const result = await firestoreService.getCollection('funds', filters);
    return result;
  } catch (error) {
    console.log(error);
  }
};
